import React from 'react'

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Center,
  Icon,
  Heading,
  Text,
  Image,
  VStack,
  Stack,
  Box,
  Link,
  useColorModeValue,
  Avatar
} from '@chakra-ui/react'

import { FiCheckCircle } from 'react-icons/fi'
import { Property } from 'generated/graphql'
import { WhatsappContact } from 'components'

import { useLogoColor } from 'hooks'

type ConfirmationModalProps = {
  isOpen: boolean
  onClose: () => void
  property: Property
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ isOpen, onClose, property }) => {
  const logo = useLogoColor()
  return (
    <Modal isOpen={isOpen} isCentered onClose={onClose} size="2xl" trapFocus={false}>
      <ModalOverlay />
      <ModalContent borderRadius="2xl" mx="4">
        <ModalCloseButton />
        <ModalBody>
          <Stack
            maxW="xs"
            mx="auto"
            py={{ base: '12', md: '16' }}
            spacing={{ base: '6', md: '10' }}
          >
            <Center>
              <Image src={logo} alt="nsoko property logo" width={130} />
            </Center>
            <Stack spacing="3" textAlign="center">
              <Text fontSize="lg" color="green.600">
                Message Sent Successfully
              </Text>
              <Text
                color={useColorModeValue('blue.500', 'blue.200')}
                fontWeight="extrabold"
                fontSize={{ base: '5xl', md: '6xl' }}
                textTransform="uppercase"
                transform="scale(1.2)"
              >
                <Icon as={FiCheckCircle} fontSize={50} color="green.400" />
              </Text>
              <Text fontSize="lg">
                Thank you for your enquiry. A message has been sent to nsoko-property -{' '}
                <Box as="span" whiteSpace="nowrap" fontWeight="bold">
                  {property?.agent?.name}{' '}
                </Box>
                or another agent will be in contact with you shortly
              </Text>
            </Stack>
            <Stack direction="column">
              <VStack spacing={2}>
                <Avatar
                  size="lg"
                  name="Prosper Otemuyiwa"
                  src={property?.agent?.photo?.formats?.thumbnail?.url}
                />
                <Heading py={2} fontSize="xl">
                  {property?.agent?.name}
                </Heading>
                <WhatsappContact propertyData={property as Property} />
              </VStack>
            </Stack>
            <Link
              fontSize="sm"
              textAlign="center"
              color={useColorModeValue('gray.600', 'gray.400')}
              textDecoration="underline"
              onClick={onClose}
            >
              Close
            </Link>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default ConfirmationModal
